'use client';

import { useEffect, useState } from 'react';

export function JSDebugger() {
  const [isClient, setIsClient] = useState(false);
  const [clickCount, setClickCount] = useState(0);

  useEffect(() => {
    setIsClient(true);
    console.log('🔍 JSDebugger: Client-side JavaScript is working');
  }, []);

  const handleClick = () => {
    setClickCount(prev => prev + 1);
    console.log('🔍 JSDebugger: onClick working, count:', clickCount + 1);
  };

  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 rounded-lg bg-black/80 p-4 text-white">
      <div className="text-xs">
        <div>Client: {isClient ? '✅' : '❌'}</div>
        <div>Clicks: {clickCount}</div>
        <button
          onClick={handleClick}
          className="mt-2 rounded bg-blue-500 px-2 py-1 text-xs hover:bg-blue-600"
        >
          Test Click
        </button>
      </div>
    </div>
  );
}